/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Capture_FailedInputs */

const th_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เริ่มบันทึกภาพไม่ได้ เลือกแหล่งภาพเพื่อลองอีกครั้ง`)
};

const en_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capture could not start. Choose a source to try again.`)
};

const ja_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプチャを開始できませんでした。映像ソースを選び直してください。`)
};

const zh_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法开始采集。请选择一个来源重试。`)
};

const es_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se ha podido iniciar la captura. Elige una fuente para reintentarlo.`)
};

const pt_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A captura não pôde começar. Escolha uma fonte para tentar de novo.`)
};

const id_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perekaman tidak bisa dimulai. Pilih sumber untuk mencoba lagi.`)
};

const fr_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La capture n’a pas pu démarrer. Choisissez une source pour réessayer.`)
};

const tl_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi nagsimula ang pagkuha. Pumili ng pinagkukunan para subukang muli.`)
};

const vi_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không bắt đầu thu hình được. Chọn một nguồn để thử lại.`)
};

const ko_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`캡처를 시작하지 못했습니다. 다시 시도하려면 소스를 고르세요.`)
};

const de_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Aufnahme konnte nicht starten. Wähle eine Quelle, um es erneut zu versuchen.`)
};

const ru_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось начать захват. Выберите источник, чтобы попробовать снова.`)
};

const tr_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yakalama başlatılamadı. Yeniden denemek için bir kaynak seçin.`)
};

const it_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'acquisizione non è partita. Scegli una sorgente per riprovare.`)
};

const pl_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się rozpocząć przechwytywania. Wybierz źródło, aby spróbować ponownie.`)
};

const uk_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не вдалося почати захоплення. Оберіть джерело, щоб спробувати ще раз.`)
};

const hi_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्चर शुरू नहीं हो सका। फिर कोशिश करने के लिए स्रोत चुनें।`)
};

const ar_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعذّر بدء الالتقاط. اختر مصدرًا لإعادة المحاولة.`)
};

const ms_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rakaman tidak dapat dimulakan. Pilih sumber untuk mencuba lagi.`)
};

const bn_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ধারণ শুরু করা যায়নি। আবার চেষ্টা করতে একটি উৎস বেছে নিন।`)
};

const zh_tw2_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法開始擷取。請選擇來源以重試。`)
};

const zh_hk2_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法開始擷取。請選擇來源以重試。`)
};

const ur_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ریکارڈنگ شروع نہ ہو سکی۔ دوبارہ کوشش کے لیے ذریعہ چنیں۔`)
};

const fa_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ضبط آغاز نشد. برای تلاش دوباره منبعی برگزینید.`)
};

const sw_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunasa hakukuanza. Chagua chanzo ili kujaribu tena.`)
};

const nl_video_capture_failed = /** @type {(inputs: Video_Capture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opnemen kon niet starten. Kies een bron om het opnieuw te proberen.`)
};

/**
* | output |
* | --- |
* | "Capture could not start. Choose a source to try again." |
*
* @param {Video_Capture_FailedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_capture_failed = /** @type {((inputs?: Video_Capture_FailedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Capture_FailedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_capture_failed(inputs)
	if (locale === "ja") return ja_video_capture_failed(inputs)
	if (locale === "zh") return zh_video_capture_failed(inputs)
	if (locale === "es") return es_video_capture_failed(inputs)
	if (locale === "pt") return pt_video_capture_failed(inputs)
	if (locale === "id") return id_video_capture_failed(inputs)
	if (locale === "fr") return fr_video_capture_failed(inputs)
	if (locale === "tl") return tl_video_capture_failed(inputs)
	if (locale === "vi") return vi_video_capture_failed(inputs)
	if (locale === "ko") return ko_video_capture_failed(inputs)
	if (locale === "de") return de_video_capture_failed(inputs)
	if (locale === "ru") return ru_video_capture_failed(inputs)
	if (locale === "tr") return tr_video_capture_failed(inputs)
	if (locale === "it") return it_video_capture_failed(inputs)
	if (locale === "pl") return pl_video_capture_failed(inputs)
	if (locale === "uk") return uk_video_capture_failed(inputs)
	if (locale === "hi") return hi_video_capture_failed(inputs)
	if (locale === "ar") return ar_video_capture_failed(inputs)
	if (locale === "ms") return ms_video_capture_failed(inputs)
	if (locale === "bn") return bn_video_capture_failed(inputs)
	if (locale === "zh-TW") return zh_tw2_video_capture_failed(inputs)
	if (locale === "zh-HK") return zh_hk2_video_capture_failed(inputs)
	if (locale === "ur") return ur_video_capture_failed(inputs)
	if (locale === "fa") return fa_video_capture_failed(inputs)
	if (locale === "sw") return sw_video_capture_failed(inputs)
	if (locale === "nl") return nl_video_capture_failed(inputs)
	return en_video_capture_failed(inputs)
});